import { useQuery } from "react-query";
import { CasAuthApi } from "../services";
export const usePasswordRules = (avoidRequest) => {
    return useQuery(["passwordRules", avoidRequest], () => {
        if (!avoidRequest) {
            return CasAuthApi.init().getPasswordRequirements();
        }
        return Promise.resolve({
            minLength: 0,
            minLowerCase: 0,
            minUpperCase: 0,
            minNumber: 0,
            minSymbol: 0,
            excludeUsername: false,
        });
    }, { retry: false });
};
//# sourceMappingURL=usePasswordRules.js.map